import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { formatWaitingDays } from 'src/utils/documentReviewList'

interface Props {
  finishedAt: string | number | null
}

/** How long this document has been sitting in the queue. */
const WaitingCellComponent = ({ finishedAt }: Props) => {
  return (
    <Typography variant="body2" css={tw`truncate`}>
      {formatWaitingDays(finishedAt)}
    </Typography>
  )
}

export const WaitingCell = memo(WaitingCellComponent)
